import React from 'react';
import { LoopsNavigation } from '../loops_navigation.jsx';
import { useFlowStore, useFlowRegistry, useFlowStoreInstance } from '../../store/react';
import { selectCurrentItem, selectLoopsDefinitions, selectLoopIterationName } from '../../store/selectors';

// Reads the fresh state at call time; avoids subscribing to the whole store
// (flowStore.getState returns a fresh object each call).
export default function LoopsNavigationWrapper() {
    const registry = useFlowRegistry();
    const flowStore = useFlowStoreInstance();
    const loops = useFlowStore((s) => s.loops);
    const setLoopIteration = useFlowStore((s) => s.setLoopIteration);
    const loopsDefinitions = useFlowStore((s) => selectLoopsDefinitions(s, registry));
    const currentItem = useFlowStore((s) => selectCurrentItem(s, registry));
    return (
        <LoopsNavigation
            loops={loops}
            loopsDefinitions={loopsDefinitions}
            currentLoopName={currentItem && currentItem.loopName}
            getIterationName={(loopName, iteration) => selectLoopIterationName(loopName, iteration, flowStore.getState(), registry)}
            onPageChange={(event, msg) => setLoopIteration(msg.loopName, msg.activePage, { goStartLoop: true })}
        />
    );
}
